import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/loader.service';
import { OnboardingService } from '../../onboarding.service';

interface DialogData {

}

@Component({
  selector: 'app-submit-otp',
  templateUrl: './submit-otp.component.html',
  styleUrls: ['./submit-otp.component.scss']
})
export class SubmitOtpComponent implements OnInit {

  verifyMobileForm: FormGroup;
  rowData;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogref: MatDialogRef<SubmitOtpComponent>,
    private loaderService: LoaderService,
    private onboardingService: OnboardingService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.rowData = this.data["data"];
    console.log(this.rowData)
    this.verifyMobileForm = new FormGroup({
      'contact_no': new FormControl(this.rowData.contact_no),
      'otp': new FormControl("")
    });
  }

  submit() {
    this.loaderService.display(true);
    this.onboardingService.submitOTP(this.verifyMobileForm.value).subscribe(
      res => {
        this.loaderService.display(false);        
        this.dialogref.close({ data: res });       
        this.toastr.success('OTP successfully verified', 'Success');
      }, err => {
        this.toastr.error('OTP does not match', 'Error');
        this.loaderService.display(false);
      }
    );
  }

  resendOtp() {
    this.onboardingService.sendOTP({ contact_no: this.rowData.contact_no }).subscribe(
      res => {
        this.toastr.success('An OTP has been shared again ', 'Success');
      },
      err => {
        this.toastr.error('An error occured sending you OTP again', 'Error');
      }
    )
  }

  cancel() {
    this.dialogref.close();
  }

}
